var _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _g8, _g9, _g10, _g11, _g12, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidDocumentScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 149,
    viewBox: "0 0 140 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 126.5V88.5H21V126.5C21 133.127 26.3726 138.5 33 138.5H107C113.627 138.5 119 133.127 119 126.5Z",
    fill: "url(#paint0_linear_249_5447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 126.5V88.5H21V126.5C21 133.127 26.3726 138.5 33 138.5H107C113.627 138.5 119 133.127 119 126.5Z",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7 20.5L33 20.5C26.3726 20.5 21 25.8726 21 32.5V81.5C21 88.1274 26.3726 93.5 33 93.5H107C113.627 93.5 119 88.1274 119 81.5V32.5C119 25.8726 113.627 20.5 107 20.5L70.7 20.5Z",
    fill: "url(#paint1_linear_249_5447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7 20.5L33 20.5C26.3726 20.5 21 25.8726 21 32.5V81.5C21 88.1274 26.3726 93.5 33 93.5H107C113.627 93.5 119 88.1274 119 81.5V32.5C119 25.8726 113.627 20.5 107 20.5L70.7 20.5Z",
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2883 42.5724C92.4628 42.5565 92.6532 42.5565 92.8118 42.5724C96.5877 42.4454 99.5862 39.3517 99.6021 35.5441C99.6021 31.6572 96.4449 28.5 92.558 28.5C88.6552 28.5 85.5139 31.6572 85.5139 35.5441C85.5139 39.3517 88.5124 42.4454 92.2883 42.5724ZM84.8795 57.7394C81.0402 55.1851 81.0402 50.9967 84.8795 48.4266C89.2583 45.5233 96.4135 45.5233 100.76 48.4266C104.6 50.9809 104.6 55.1692 100.76 57.7394C96.3976 60.6586 89.2424 60.6586 84.8795 57.7394Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 99.6491C34 98.4622 34.9622 97.5 36.1491 97.5H67.3156C68.5025 97.5 69.4647 98.4622 69.4647 99.6491C69.4647 100.836 68.5025 101.798 67.3156 101.798H36.1491C34.9622 101.798 34 100.836 34 99.6491Z",
    fill: "url(#paint2_linear_249_5447)",
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 111.254C34 110.542 34.5773 109.965 35.2895 109.965H80.8509C81.563 109.965 82.1404 110.542 82.1404 111.254C82.1404 111.967 81.563 112.544 80.8509 112.544H35.2895C34.5773 112.544 34 111.967 34 111.254Z",
    fill: "url(#paint3_linear_249_5447)",
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 120.711C34 119.998 34.5773 119.421 35.2895 119.421H80.8509C81.563 119.421 82.1404 119.998 82.1404 120.711C82.1404 121.423 81.563 122 80.8509 122H35.2895C34.5773 122 34 121.423 34 120.711Z",
    fill: "url(#paint4_linear_249_5447)",
    shapeRendering: "crispEdges"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter6_b_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 88.5V28.5C119 21.8726 113.627 16.5 107 16.5H33C26.3726 16.5 21 21.8726 21 28.5V88.5",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7 88.5L21 88.5V126.5C21 133.127 26.3726 138.5 33 138.5H107C113.627 138.5 119 133.127 119 126.5V88.5L70.7 88.5Z",
    fill: "url(#paint5_linear_249_5447)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 107.211C35 106.266 35.7658 105.5 36.7105 105.5H61.5165C62.4612 105.5 63.227 106.266 63.227 107.211C63.227 108.155 62.4612 108.921 61.5165 108.921H36.7105C35.7658 108.921 35 108.155 35 107.211Z",
    fill: "url(#paint6_linear_249_5447)",
    shapeRendering: "crispEdges"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 116.447C35 115.881 35.4595 115.421 36.0263 115.421H72.2895C72.8563 115.421 73.3158 115.881 73.3158 116.447C73.3158 117.014 72.8563 117.474 72.2895 117.474H36.0263C35.4595 117.474 35 117.014 35 116.447Z",
    fill: "url(#paint7_linear_249_5447)",
    shapeRendering: "crispEdges"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 123.974C35 123.407 35.4595 122.947 36.0263 122.947H72.2895C72.8563 122.947 73.3158 123.407 73.3158 123.974C73.3158 124.541 72.8563 125 72.2895 125H36.0263C35.4595 125 35 124.541 35 123.974Z",
    fill: "url(#paint8_linear_249_5447)",
    shapeRendering: "crispEdges"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 88.5L21 127.5C21 134.127 26.3726 139.5 33 139.5L107 139.5C113.627 139.5 119 134.127 119 127.5L119 88.5",
    stroke: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_249_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 89C1.5 88.1716 2.17157 87.5 3 87.5H137C137.828 87.5 138.5 88.1716 138.5 89C138.5 89.8284 137.828 90.5 137 90.5H3C2.17157 90.5 1.5 89.8284 1.5 89Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.5 15.5V29.5H132.5V15.5C132.5 8.59644 126.904 3 120 3H106V4H120C126.351 4 131.5 9.14873 131.5 15.5ZM8.5 122.5V136.5C8.5 142.851 13.6487 148 20 148H34V149H20C13.0964 149 7.5 143.404 7.5 136.5V122.5H8.5ZM131.5 122.5V136.5C131.5 142.851 126.351 148 120 148H106V149H120C126.904 149 132.5 143.404 132.5 136.5V122.5H131.5ZM8.5 29.5V15.5C8.5 9.14873 13.6487 4 20 4H34V3H20C13.0964 3 7.5 8.59644 7.5 15.5V29.5H8.5Z",
    fill: "url(#paint9_linear_249_5447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_249_5447",
    x: 0.5,
    y: 68,
    width: 139,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_249_5447",
    x: 0.5,
    y: 0,
    width: 139,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_249_5447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_249_5447",
    x: 74,
    y: 20.5,
    width: 37.64,
    height: 47.4288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_249_5447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_249_5447",
    x: 33,
    y: 97.5,
    width: 37.4647,
    height: 6.29822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_249_5447",
    x: 33,
    y: 109.965,
    width: 50.1404,
    height: 4.57892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_249_5447",
    x: 33,
    y: 119.421,
    width: 50.1404,
    height: 4.57892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_249_5447",
    x: 15.5,
    y: 11,
    width: 109,
    height: 82.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_249_5447",
    x: 34,
    y: 105.5,
    width: 30.2271,
    height: 5.42108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_249_5447",
    x: 34,
    y: 115.421,
    width: 40.3158,
    height: 4.05261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_249_5447",
    x: 34,
    y: 122.947,
    width: 40.3158,
    height: 4.05261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_249_5447",
    x: 15.5,
    y: 83.5,
    width: 109,
    height: 61.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_249_5447",
    x: 0.5,
    y: 87.5,
    width: 139,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_5447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_5447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_5447",
    x1: 136.15,
    y1: 93.8223,
    x2: 47.8897,
    y2: 138.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#380C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E49DF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_249_5447",
    x1: 136.15,
    y1: 28.2706,
    x2: 37.0696,
    y2: 62.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#380C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E49DF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_249_5447",
    x1: 40.4474,
    y1: 99.6491,
    x2: 71.8246,
    y2: 99.6491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_249_5447",
    x1: 41.573,
    y1: 111.254,
    x2: 87.4424,
    y2: 111.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_249_5447",
    x1: 41.573,
    y1: 120.711,
    x2: 87.4424,
    y2: 120.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_249_5447",
    x1: 136.15,
    y1: 93.8223,
    x2: 47.8897,
    y2: 138.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#380C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E49DF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_249_5447",
    x1: 40.1316,
    y1: 107.211,
    x2: 65.1053,
    y2: 107.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_249_5447",
    x1: 41.0275,
    y1: 116.447,
    x2: 77.5358,
    y2: 116.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_249_5447",
    x1: 41.0275,
    y1: 123.974,
    x2: 77.5358,
    y2: 123.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_249_5447",
    x1: 145,
    y1: 43,
    x2: -3.5,
    y2: 85.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832222,
    stopColor: "#DE98F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidDocumentScan);
export default __webpack_public_path__ + "static/media/bfid-document-scan.b5b8dd2872fa1f4cda5997919bf2be5d.svg";
export { ForwardRef as ReactComponent };